<template>
  <vue-scroll>
  <div class="claim-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="保函编号" prop="orderNumber">
                  <Input v-model="filterModel.orderNumber" placeholder="输入保函编号" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="项目名称" prop="prjName">
                  <Input v-model="filterModel.prjName" placeholder="输入项目名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="代偿方式" prop="method">
                  <Select v-model="filterModel.method" filterable>
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.claimMethod)" :key="idx" :value="tp.value">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="状态" prop="status">
                  <Select v-model="filterModel.status">
                    <Option :value="null">不限</Option>
                    <Option :value="0">待代偿</Option>
                    <Option :value="1">已代偿</Option>
                    <Option :value="2">拒绝代偿</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="代偿金额范围" prop="amountStart">
                  <InputNumber :min="0" :step="10000" style="width: 100px" v-model="filterModel.amountStart" placeholder="从(元)"></InputNumber>
                  -
                  <InputNumber :min="0" :step="10000" style="width: 100px" v-model="filterModel.amountEnd" placeholder="到(元)"></InputNumber>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <!-- <Button type="primary" to="/claims/new" icon="md-add">新增代偿</Button> -->
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
  </vue-scroll>
</template>

<script>
import moment from 'moment'
export default {
  name: 'claim-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '保函编号',
          width: 160,
          key: 'orderNumber',
          resizable: true,
        },
        {
          title: '项目名称',
          key: 'projectName',
          resizable: true,
        },
        {
          title: '状态',
          key: 'status',
          resizable: true,
          width: 140,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.getStatus(params.row).color
              }
            }, this.getStatus(params.row).text)
          }
        },
        {
          title: '代偿方式',
          key: 'method',
          width: 160,
          resizable: true,
        },
        {
          title: '代偿金额',
          key: 'amount',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.amount ? Math.round(params.row.amount / 100 / 1000) / 10 + '万' : null)
          }
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.createTime ? this.getMoment(params.row.createTime).format('YYYY-MM-DD') : null)
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '查看保函',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-clipboard'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'guarantee-list', query: {orderNumber: params.row.orderNumber}})
                    }
                  }
                }, null),
              ]),
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                },
                style: {
                  marginLeft: '5px'
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'claim-detail', params: {id: params.row.id}})
                    }
                  }
                }, null),
              ]),
              this.canEdit(params.row) ? h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                },
                style: {
                  marginLeft: '5px'
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'claim-edit', params: {id: params.row.id, orderNumber: params.row.orderNumber}})
                    }
                  }
                }, null),
              ]) : null,
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        orderNumber: null,
        status: null,
        guarantorId: null,
        prjId: null,
        prjName: null,
        method: null,
        reasonByOwner: null,
        reasonByContractor: null,
        amountStart: null,
        amountEnd: null,
        needAudit: null,
        createTimeStart: null,
        createTimeEnd: null,
        auditTimeStart: null,
        auditTimeEnd: null,
        cityId: null,
        industryId: null
      }
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
    window.less.modifyVars({
      '@primaryColor': '#ff9900'
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    canEdit (item) {
      let status = item.status
      let needAudit = item.needAudit
      if (status === 0) {
        if (needAudit) {
          if (this.$store.getters.userInfo.type === 127) {
            return true
          } else if (this.$store.getters.userInfo.type === 7) {
            return this.getConfig('ENABLE_GEN_SUPV_CLAIM_GUA')
          } else if (this.$store.getters.userInfo.type === 5) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getStatus (item) {
      let status = item.status
      let needAudit = item.needAudit
      if (status === 1) {
        return {
          text: '已代偿',
          color: 'success'
        }
      } else if (status === 2) {
        return {
          text: '拒绝代偿',
          color: 'error'
        }
      } else if (status === 0) {
        if (needAudit) {
          return {
            text: '待审核',
            color: 'warning'
          }
        } else {
          return {
            text: '未代偿',
            color: 'default'
          }
        }
      }
    },
    getMoment (dt) {
      return moment(dt)
    },
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Guarantee.listClaims(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
  }
}
</script>

<style lang="less" scoped>
.claim-list {
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
